/**
 * PKCE (S256) y el `state`, con la Web Crypto del navegador. Sin
 * dependencias: `crypto.getRandomValues` y `crypto.subtle.digest` bastan.
 */

/** base64url sin relleno (RFC 4648 §5), que es lo que piden PKCE y los JWT. */
export const base64UrlEncode = (bytes: Uint8Array): string => {
  let binary = "";
  for (const byte of bytes) binary += String.fromCharCode(byte);
  return btoa(binary)
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
};

/**
 * Texto aleatorio seguro. 32 bytes dan un verifier de 43 caracteres, el
 * mínimo que admite la RFC 7636.
 */
export const randomToken = (bytes = 32): string => {
  const buffer = new Uint8Array(bytes);
  crypto.getRandomValues(buffer);
  return base64UrlEncode(buffer);
};

/** `code_challenge` = base64url(SHA-256(verifier)). */
export const codeChallengeFor = async (verifier: string): Promise<string> => {
  const digest = await crypto.subtle.digest(
    "SHA-256",
    new TextEncoder().encode(verifier),
  );
  return base64UrlEncode(new Uint8Array(digest));
};
